import { render, staticRenderFns } from "./header.vue?vue&type=template&id=08445b4a&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=08445b4a&prod&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=08445b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08445b4a",
  null
  
)

export default component.exports